import { render, staticRenderFns } from "./TableRecord.vue?vue&type=template&id=4ee6c6f7&scoped=true"
import script from "./TableRecord.vue?vue&type=script&lang=js"
export * from "./TableRecord.vue?vue&type=script&lang=js"
import style0 from "./TableRecord.vue?vue&type=style&index=0&id=4ee6c6f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee6c6f7",
  null
  
)

export default component.exports